var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from '@doordash/component-modal';
import { StackChildren, InlineChildren, Text } from '@doordash/design-language';
import Button from '@doordash/component-button';
import styled from 'styled-components';
import DashPassStrings from './DashPassStrings';
import { useActivateTeamAccountBenefitMutation } from './hooks/useActivateTeamAccountBenefitMutation';
import { getSelectedTeamAccount } from '../../selectors/uiSelector';
import { WorkflowName, OnboardingStep, } from '../../types/GloblalTypes';
import { useGetWorkflowStatusQuery } from './hooks/useGetWorkflowStatusQuery';
import track from '../../utils/track';
import * as Sentry from '@sentry/react';
import { captureSentryEvent } from '../../utils/errorHandling';
import { ProductFamily, ProductWorkflow, CustomerType, } from '../../types/_ProductSpecificTypes';
import { useSetOnboardingStepMutation } from '../SelfServe/Onboarding/useSetOnboardingStepMutation';
import { useHistory } from 'react-router-dom';
import { fetchPortalData } from '../AppStructure/portal_slice';
import { isOnAdminRoute } from '../AppStructure/routeUtils';
import { GenericErrorBanner } from './GenericErrorBanner';
import { DashPassEvents } from '../../constants/events';
export var ButtonGroupContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 300px;\n"], ["\n  max-width: 300px;\n"])));
var MAX_POLLING_ATTEMPT = 32;
export var BenefitActivationModal = function (_a) {
    var _b, _c, _d;
    var title = _a.title, numEmployees = _a.numEmployees, workBenefit = _a.workBenefit, onClose = _a.onClose, isExpensedMealsActive = _a.isExpensedMealsActive, isDashPassActive = _a.isDashPassActive;
    var history = useHistory();
    var dispatch = useDispatch();
    var teamAccountId = useSelector(getSelectedTeamAccount);
    var _e = __read(React.useState(false), 2), isPollingStatus = _e[0], setIsPollingStatus = _e[1];
    var _f = __read(React.useState(0), 2), successPollCount = _f[0], setSuccessPollCount = _f[1];
    var _g = __read(React.useState(0), 2), failurePollCount = _g[0], setFailurePollCount = _g[1];
    var _h = __read(useActivateTeamAccountBenefitMutation(teamAccountId, workBenefit, {
        onCompleted: function () {
            setOnboardingStep();
            setActivationSucceeded(true);
            track(DashPassEvents.SELF_SERVE_BENEFIT_ACTIVATION, {
                work_benefit: workBenefit,
                has_dashpass: isDashPassActive,
                has_expensed_meals: isExpensedMealsActive,
            });
        },
    }), 2), activateBenefit = _h[0], _j = _h[1], activateBenefitLoading = _j.loading, activateBenefitData = _j.data, activateBenefitError = _j.error;
    var setOnboardingStep = useSetOnboardingStepMutation(teamAccountId, OnboardingStep.ONBOARDING_STEP_ACTIVATE_DASHPASS).setOnboardingStep;
    // activationSucceeded means the activation succeeded from user's POV,
    // though the workflow may or may not have succeeded yet in back end
    var _k = __read(React.useState(false), 2), activationSucceeded = _k[0], setActivationSucceeded = _k[1];
    // activationFailed means either the activation failed on BE,
    // or there were too many polling attempts
    var _l = __read(React.useState(false), 2), activationFailed = _l[0], setActivationFailed = _l[1];
    var _m = useGetWorkflowStatusQuery({
        skip: !Boolean((_b = activateBenefitData === null || activateBenefitData === void 0 ? void 0 : activateBenefitData.activateTeamAccountBenefit) === null || _b === void 0 ? void 0 : _b.workflowId),
        variables: {
            workflowId: (_d = (_c = activateBenefitData === null || activateBenefitData === void 0 ? void 0 : activateBenefitData.activateTeamAccountBenefit) === null || _c === void 0 ? void 0 : _c.workflowId) !== null && _d !== void 0 ? _d : '',
            workflowName: WorkflowName.WORKFLOW_NAME_ACTIVATE_BENEFIT,
        },
    }, {
        setSuccessPollCount: setSuccessPollCount,
        setFailurePollCount: setFailurePollCount,
        setIsPollingStatus: setIsPollingStatus,
    }, {
        onSuccess: function () {
            var mountOnAdminRoute = isOnAdminRoute((history && history.location && history.location.pathname) || '');
            var options = {
                skipAutoSelectingTeamAccount: !!mountOnAdminRoute,
            };
            dispatch(fetchPortalData(options));
            onClose();
        },
        onError: function () {
            var _a, _b;
            setActivationFailed(true);
            captureSentryEvent(Sentry.Severity.Error, 'encountered error in activateTeamAccountBenefit', {
                productFamily: ProductFamily.DashpassForWork,
                productWorkflow: ProductWorkflow.ActivateBenefit,
                customerType: CustomerType.SelfServeCustomer,
            }, {
                workBenefit: workBenefit,
                successPollCount: successPollCount,
                failurePollCount: failurePollCount,
                isPollingStatus: isPollingStatus,
                workflowId: (_b = (_a = activateBenefitData === null || activateBenefitData === void 0 ? void 0 : activateBenefitData.activateTeamAccountBenefit) === null || _a === void 0 ? void 0 : _a.workflowId) !== null && _b !== void 0 ? _b : 'unknown',
            });
        },
    }), isWorkflowQueryLoading = _m.loading, stopPolling = _m.stopPolling;
    React.useEffect(function () {
        if (successPollCount + failurePollCount >= MAX_POLLING_ATTEMPT) {
            stopPolling();
            setIsPollingStatus(false);
            setActivationFailed(true);
        }
    }, [successPollCount, failurePollCount, stopPolling]);
    var handleActivation = function () {
        activateBenefit();
    };
    var showErrorMessage = activateBenefitError || activationFailed;
    var showLoadingButton = activateBenefitLoading || (activationSucceeded && !showErrorMessage);
    return (React.createElement(Modal, { onClose: onClose, title: title },
        React.createElement(StackChildren, { size: StackChildren.Sizes.Small },
            React.createElement(Text, { color: Text.Colors.TextSecondary },
                DashPassStrings.benefitActivationModalContent1Part1(),
                React.createElement(Text, { weight: Text.Weights.Bold, display: Text.DisplayModes.Inline }, DashPassStrings.benefitActivationModalContent1Part2(numEmployees)),
                DashPassStrings.benefitActivationModalContent1Part3(),
                React.createElement(Text, { weight: Text.Weights.Bold, display: Text.DisplayModes.Inline }, DashPassStrings.benefitActivationModalContent1Part4()),
                DashPassStrings.benefitActivationModalContent1Part5()),
            React.createElement(Text, { color: Text.Colors.TextSecondary }, DashPassStrings.benefitActivationModalContent2()),
            showErrorMessage && React.createElement(GenericErrorBanner, null),
            React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center, justifyContent: InlineChildren.Justification.FlexEnd },
                React.createElement(ButtonGroupContainer, null,
                    React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center },
                        React.createElement(Button, { type: Button.Types.Tertiary, onClick: onClose }, DashPassStrings.benefitActivationModalCancelButton()),
                        React.createElement(Button, { type: Button.Types.PrimaryPill, onClick: handleActivation, state: showLoadingButton
                                ? Button.States.Loading
                                : Button.States.Default, disabled: showLoadingButton }, DashPassStrings.benefitActivationModalConfirmButton())))))));
};
export default BenefitActivationModal;
var templateObject_1;
